export enum TargetingFiltersEnum {
    contactName = 'contactName',
    outletName = 'outletName',
    jobRole = 'jobRole',
    jobTitle = 'jobTitle',
    location = 'location',
    country = 'country',
    province = 'province',
    city = 'city',
    deliveryStatus = 'deliveryStatus',

    subject = 'subject',
    language = 'language',
    targetAudienceRegion = 'areaOfCoverage', // targetAudienceRegion is new property name, backend not changed yet
    aocCountry = 'aocCountry',
    aocProvince = 'aocProvince',
    aocCity = 'aocCity',
    mediaMarket = 'mediaMarket',
    coverageFocus = 'coverageFocus',
    audienceReach = 'audienceReach',
    marketSector = 'marketSector',
    mediaType = 'mediaType',
    productType = 'productType',
    productFrequency = 'productFrequency',
    targetAudience = 'targetAudience',

    list = 'list',
    distribution = 'distribution',
    status = 'status',

    email = 'email',
    streamContent = 'streamContent'
}
